<template>
  <pl-dialog
    :title="'Templates'"
    :size="'md'"
    :disableOutsideClick="true"
    @close="$emit('close')"
  >
    <div class="px-7 py-3 flex-grow overflow-auto">
      <div
        class="mb-3 flex items-center justify-between space-x-1 rounded p-1.5 bg-trueGray-100 border border-solid border-gray-200"
      >
        <div>
          <button
            @click="saved_feedback_is_selected = true"
            class="font-medium"
            :class="
              saved_feedback_is_selected
                ? 'rounded border border-solid border-gray-200 bg-white py-2 px-3 '
                : 'pl-3'
            "
          >
            Saved Feedback
          </button>
          <button
            @click="saved_feedback_is_selected = false"
            class="font-medium"
            :class="
              !saved_feedback_is_selected
                ? 'rounded border border-solid border-gray-200 bg-white py-2 px-3'
                : 'pl-3'
            "
          >
            Suggested Feedback
          </button>
        </div>
        <div>
          <button
            v-if="saved_feedback_is_selected"
            @click="newSavedFeedback"
            class="sample mr-2 px-5 py-1.5 cursor-pointer text-xs font-semibold text-white bg-blueGray-500 rounded"
          >
            <span>New</span>
          </button>
          <button
            v-if="saved_feedback_is_selected"
            @click="showImportFeedback"
            class="sample mr-2 px-5 py-1.5 cursor-pointer text-xs font-semibold text-white bg-blueGray-500 rounded"
          >
            <span>Import</span>
          </button>
          <button
            class="sample mr-2 px-5 py-1.5 cursor-pointer text-xs font-semibold text-white bg-blueGray-500 rounded"
            @click="refresh"
          >
            <i class="fas fa-sync" aria-hidden="true" />
          </button>
        </div>
      </div>
      <div v-if="saved_feedback_is_selected">
        <div v-if="saved_feedback_to_display.length">
          <div
            v-for="(feedback, index) in saved_feedback_to_display"
            :key="index"
            class="mb-3 rounded border border-solid border-gray-200 bg-gray-100 relative"
          >
            <div class="font-medium py-2.5 pl-2.5 pr-5 break-all">
              {{ feedback.text }}
            </div>
            <div class="border-t" />
            <div class="flex justify-end px-2.5 py-2">
              <button
                class="sample py-1 px-2 rounded bg-primary text-white text-xs font-semibold"
                @click="selectSavedFeedback(feedback)"
              >
                Add Feedback
              </button>
            </div>
            <div class="absolute top-2.5 right-2.5">
              <v-dropdown placement="right">
                <template v-slot:button>
                  <i
                    class="fas fa-ellipsis-v cursor-pointer text-gray-500 w-full flex items-center justify-end text-md"
                  />
                </template>
                <template v-slot:content>
                  <ul class="w-28">
                    <li
                      @click="editSavedFeedback(feedback)"
                      class="sample group px-3 py-2 rounded-t flex items-center w-full h-9 cursor-pointer hover:bg-gray-100"
                    >
                      <i class="fa fa-edit" aria-hidden="true"></i>
                      <span class="mx-3 text-xs"> Edit</span>
                    </li>
                    <li
                      @click="deleteSavedFeedback(feedback)"
                      class="sample group px-3 py-2 rounded-b flex items-center w-full h-9 cursor-pointer hover:bg-gray-100 text-red-600"
                    >
                      <i class="text-red-500 fas fa-trash-alt" />
                      <span class="mx-3 text-xs px-1"> Delete</span>
                    </li>
                  </ul>
                </template>
              </v-dropdown>
            </div>
          </div>
        </div>
        <div v-else>
          You have no saved feedback templates. Create a new template or import
          some from an existing course.
        </div>
      </div>
      <div v-else>
        <div
          v-for="(feedback, index) in automated_feedback_to_display"
          :key="index"
          class="mb-3 rounded border border-solid border-gray-200 bg-gray-100"
        >
          <div class="font-medium p-2.5">{{ feedback.text }}</div>
          <button
            v-my-tooltip="{
              content: feedback.explanation,
              placement: 'right',
            }"
            class="pl-2.5 pb-2.5 text-pinky"
          >
            Why this suggestion?
          </button>
          <div class="border-t" />
          <div class="flex justify-end px-2.5 py-2">
            <button
              class="sample py-1 px-2 rounded bg-primary text-white text-xs font-semibold"
              @click="selectAutomatedFeedback(feedback)"
            >
              Add Feedback
            </button>
          </div>
        </div>
      </div>
    </div>
  </pl-dialog>
</template>

<script>
  import { mapGetters } from 'vuex';
  import Tooltip from 'components/Tooltip.vue';
  import { EventBus } from 'utils/event-bus';
  import {
    refreshFeedback,
    selectFeedback,
  } from 'services/liveDiscussion/automated_feedback';
  export default {
    components: {
      Tooltip,
    },
    props: {
      activityType: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        saved_feedback_is_selected: true,
        saved_feedback: [],
        taken_suggestions: [],
      };
    },
    computed: {
      ...mapGetters([
        'getProfile',
        'getCourseDetail',
        'getStudentSummary',
        'getStudentSummaryLD',
      ]),
      saved_feedback_to_display_written() {
        if (this.saved_feedback && this.saved_feedback.length > 0) {
          return this.getCourseDetail.saved_online_feedback.filter(
            (feedback) => {
              return !this.saved_feedback.includes(feedback.id);
            }
          );
        } else {
          return this.getCourseDetail.saved_online_feedback;
        }
      },
      saved_feedback_to_display_verbal() {
        if (this.saved_feedback && this.saved_feedback.length > 0)
          return this.getCourseDetail.saved_live_feedback.filter((feedback) => {
            return !this.saved_feedback.includes(feedback.id);
          });
        else return this.getCourseDetail.saved_live_feedback;
      },
      saved_feedback_to_display() {
        if (this.activityType === 'written')
          return this.saved_feedback_to_display_written;
        return this.saved_feedback_to_display_verbal;
      },
      automated_feedback_to_display_written() {
        return this.getStudentSummary.automated_feedback.filter((feedback) => {
          return !this.taken_suggestions.includes(feedback.tag);
        });
      },
      automated_feedback_to_display_verbal() {
        return this.getStudentSummaryLD.automated_feedback.filter(
          (feedback) => {
            return !this.taken_suggestions.includes(feedback.tag);
          }
        );
      },
      automated_feedback_to_display() {
        if (this.activityType === 'written')
          return this.automated_feedback_to_display_written;
        return this.automated_feedback_to_display_verbal;
      },
    },
    methods: {
      newSavedFeedback() {
        if (!this.getProfile.is_paid) {
          const text =
            'save feedback template feature for both types of RoundTables.';
          EventBus.$emit('open-upgrade-modal', text);
          return;
        }
        this.$emit('close');
        EventBus.$emit('newSavedFeedback');
      },
      showImportFeedback() {
        if (!this.getProfile.is_paid) {
          const text =
            'save feedback template feature for both types of RoundTables.';
          EventBus.$emit('open-upgrade-modal', text);
          return;
        }
        this.$emit('close');
        EventBus.$emit('showImportFeedback');
      },
      selectSavedFeedback(feedback) {
        if (!this.getProfile.is_paid) {
          const text =
            'save feedback template feature for both types of RoundTables.';
          EventBus.$emit('open-upgrade-modal', text);
          return;
        }
        EventBus.$emit('selectSavedFeedback', feedback.text);

        if (this.activityType === 'written') {
          this.$store
            .dispatch('selectSavedFeedback', {
              feedback_id: feedback.id,
              submission_id: this.getStudentSummary.submission_id,
            })
            .then(() => this.saved_feedback.push(feedback.id))
            .catch(console.log);
        } else {
          this.$store
            .dispatch('selectSavedFeedbackLD', {
              feedback_id: feedback.id,
              participation_id: this.getStudentSummaryLD.participation_id,
            })
            .then(() => this.saved_feedback.push(feedback.id))
            .catch(console.log);
        }
      },
      refreshSavedFeedback() {
        return (this.saved_feedback = []);
      },
      selectAutomatedFeedback(feedback) {
        if (!this.getProfile.is_paid) {
          const text =
            'save feedback template feature for both types of RoundTables.';
          EventBus.$emit('open-upgrade-modal', text);
          return;
        }
        EventBus.$emit('selectSuggestFeedback', feedback.text);
        if (this.activityType === 'written') {
          this.$store
            .dispatch('selectAutomatedFeedback', {
              tag: feedback.tag,
              submission_id: this.getStudentSummary.submission_id,
            })
            .then(() => this.taken_suggestions.push(feedback.tag))
            .catch(console.log);
        } else {
          selectFeedback(this.getStudentSummaryLD.participation_id, {
            tag: feedback.tag,
          })
            .then(() => this.taken_suggestions.push(feedback.tag))
            .catch(console.log);
        }
      },
      refreshAutomatedFeedback() {
        if (this.activityType === 'written') {
          this.$store
            .dispatch('refreshAutomatedFeedback', {
              submission_id: this.getStudentSummary.submission_id,
            })
            .then(() => (this.taken_suggestions = []));
        } else {
          refreshFeedback(this.getStudentSummaryLD.participation_id)
            .then(() => (this.taken_suggestions = []))
            .catch(console.log);
        }
      },
      refresh() {
        if (this.saved_feedback_is_selected) {
          this.refreshSavedFeedback();
        } else {
          this.refreshAutomatedFeedback();
        }
      },
      editSavedFeedback(feedback) {
        if (!this.getProfile.is_paid) {
          const text =
            'save feedback template feature for both types of RoundTables.';
          EventBus.$emit('open-upgrade-modal', text);
          return;
        }
        this.$emit('close');
        EventBus.$emit('editSavedFeedback', {
          feedback_id: feedback.id,
          feedback_content: feedback.text,
        });
      },
      deleteSavedFeedback(feedback) {
        if (!this.getProfile.is_paid) {
          const text =
            'save feedback template feature for both types of RoundTables.';
          EventBus.$emit('open-upgrade-modal', text);
          return;
        }
        this.$emit('close');
        EventBus.$emit('deleteSavedFeedback', feedback);
      },
    },
    mounted() {
      this.saved_feedback =
        this.activityType === 'written'
          ? this.getStudentSummary.saved_feedback
          : this.getStudentSummaryLD.saved_feedback;
      this.taken_suggestions =
        this.activityType === 'written'
          ? this.getStudentSummary.taken_suggestions
          : this.getStudentSummaryLD.taken_suggestions;
    },
  };
</script>
<style lang="stylus" scoped></style>



// WEBPACK FOOTER //
// templatesModal.vue?336bc810